const metatitle = [
  {
    path: "/",
    title: "Trusted Pregnancy & Maternity Care in Pune - Myprega",
    description:
      "Looking for the best maternity hospital near you? Myprega: A tech-integrated, innovative, & affordable pregnancy care package with 9 experts for 9 months, daily health tracking, and risk prevention. All-in-one care, right at your fingertips. Explore Now!",
  },
  {
    path: "/about",
    title: "The Future of Maternity/Pregnancy Care | Tech-Driven & Affordable",
    description:
      "Learn how Myprega is transforming maternity/pregnancy care with innovative technology, 9-month expert support, prevention-first focus, and an affordable solution for expectant mothers at their fingertips!",
  },
  {
    path: "/elemental-care",
    title:
      "7-Days Free| Best Maternity Hospital/Care for Normal Delivery | Myprega",
    description:
      "Experience Myprega's 7-day free trial! Modern, safe, and complete pregnancy care. Don’t just take our word for it—try first, trust later! Trusted as the best maternity care for normal delivery in Pune. Join today!",
  },
  {
    path: "/cherish-care",
    title:
      "Comprehensive Maternity/Pregnancy Package | Tech-Driven & Affordable",
    description:
      "Discover our tech-driven, innovative, and best maternity / pregnancy care package: daily pregnancy health tracking, 9 medical experts for each mom, risk prevention, and complete 9-month care at affordable prices.",
  },
  {
    path: "/daily-handholding",
    title:
      "Daily Handholding Pregnancy Care | Myprega",
    description:
      "Explore Myprega's Daily Handholding pregnancy care with daily health tracking, expert support, and integrated subscription checkout.",
  },
  {
    path: "/pricing",
    title: "Pregnancy Care Pricing Plans | Myprega",
    description:
      "Explore pricing for myprega’s complete tech-driven pregnancy care solution. Get daily health tracking, doctor guidance & full support—affordably.",
  },
  {
    path: "/antenatal-care-what-it-is-and-why-it-matters",
    title: "Antenatal Care in Pregnancy: What It Is & Why It Matters",
    description:
      "Let’s learn why prenatal care matters—from early risk detection to emotional support. Read how integrated care ensures a safe, healthy pregnancy journey.",
  },
  {
    path: "/first-trimester-guide-what-to-expect",
    title: "First Trimester of Pregnancy: What to Expect & Tips",
    description:
      "ExploFirst trimester? Learn about early pregnancy signs, essential scans, nutrition, and mental wellbeing for a healthy and stress-free start. Read the full blog!",
  },
  {
    path: "/first-trimester-symptoms-for-moms",
    title: "Your Guide to First Trimester Symptoms - Myprega",
    description:
      "Find out common first-trimester symptoms, what they mean, and how to manage them. A must-read guide for moms-to-be navigating early pregnancy changes.",
  },
  {
    path: "/pregnancy-diet-plan-guide",
    title: "Pregnancy Diet Plan: What to Eat & Avoid During Pregnancy",
    description:
      "Find out what to eat and avoid during pregnancy, trimester by trimester. Support your baby’s development with smart food choices. Read the full blog!",
  },
  {
    path: "/best-pregnancy-hospital-in-pune",
    title: "Best Pregnancy Care Hospital in Pune | Myprega",
    description:
      "Searching for a trusted pregnancy hospital in Pune? Myprega offers expert care, modern facilities & full support through every stage of pregnancy",
  },
];

export default metatitle;
